<section
	*ngIf="shouldRenderBanner()"
	[attr.type]="quality"
	class="service-evolution-quality-banner zk-flex zk-gap-2 zk-items-center"
>
	<span [ngClass]="['freud-icon', icons.get(quality)]"></span>
	<p [innerHTML]="getBannerMessage() | translate"></p>
</section>
<section
	*ngIf="isLoadingInput()"
	class="
		service-evolution-quality-banner service-evolution-quality-loading
		zk-items-center
	"
>
	<freud-loader></freud-loader>
</section>
